import { render, staticRenderFns } from "./InvoicesWithDetails.vue?vue&type=template&id=2e1714d5&scoped=true"
import script from "./InvoicesWithDetails.vue?vue&type=script&lang=js"
export * from "./InvoicesWithDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoicesWithDetails.vue?vue&type=style&index=0&id=2e1714d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1714d5",
  null
  
)

export default component.exports